import { SubscriptionBundle } from './SubscriptionBundle';

export class RegisterState {
    sectionOrder: Array<string> = ['network_check', 'personalize', 'account_creation', 'payment'];
    currentSection: number;
    sectionCompleted: Array<boolean>;
    subscriptionBundle: SubscriptionBundle;

    constructor(object?: any) {
        this.currentSection = object && object.currentSection || 0;
        this.sectionCompleted = object && object.sectionCompleted || [false, false, false, false];
        this.subscriptionBundle = object && object.subscriptionBundle || new SubscriptionBundle();
    }
    /**
     * Return if the object is a new one or had been already updated
     */
    isEmpty(): boolean {
        return this.currentSection === 0;
    }
}
